import React from 'react';
import { Theme } from '../context/ThemeContext';
import { useTheme } from '../hooks/useTheme';
import { useTranslation } from '../hooks/useTranslation';

const SunIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" /></svg>
);
const MoonIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" /></svg>
);
const SystemIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>
);

const ThemeSwitcher: React.FC = () => {
    const { theme, setTheme } = useTheme();
    const { t } = useTranslation();

    const themes: { name: Theme, icon: React.ReactElement }[] = [
        { name: 'light', icon: <SunIcon /> },
        { name: 'dark', icon: <MoonIcon /> },
        { name: 'system', icon: <SystemIcon /> },
    ];

    return (
        <div className="flex items-center space-x-2">
            <span className="text-sm font-medium">{t('theme_switcher')}:</span>
            <div className="flex items-center p-1 bg-slate-200 dark:bg-slate-700 rounded-full">
                {themes.map((t) => (
                    <button
                        key={t.name}
                        onClick={() => setTheme(t.name)}
                        className={`p-1.5 rounded-full transition-colors ${
                            theme === t.name ? 'bg-brand-green text-white' : 'text-slate-500 dark:text-slate-400 hover:text-brand-dark dark:hover:text-white'
                        }`}
                        aria-label={`Switch to ${t.name} theme`}
                    >
                        {t.icon}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default ThemeSwitcher;